import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';


const getCardStyles = () => {
    const width = window.innerWidth;
    let cardFlexBasis;
    let imageHeight;

    if (width >= 992) {
        cardFlexBasis = 'calc(25% - 1rem)';
        imageHeight = '250px'; 
    } else if (width >= 768) {
        cardFlexBasis = 'calc(40% - 1rem)';
        imageHeight = '200px'; 
    } else {
        cardFlexBasis = 'calc(66.66% - 1rem)';
        imageHeight = '180px'; 
    }

    return {
        cardSlideItem: {
            flex: `0 0 ${cardFlexBasis}`,
            minWidth: '250px',
            marginBottom: '1rem',
        },
        image: {
            width: '100%',
            height: imageHeight,
            objectFit: 'cover'
        }
    };
};


const baseStyles = {
    scrollingRowContainer: {
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
        paddingBottom: '15px', 
        scrollBehavior: 'smooth',
        msOverflowStyle: 'none', 
        scrollbarWidth: 'none', 
    },
    scrollingRow: {
        display: 'flex',
        flexWrap: 'nowrap', 
        gap: '1rem', 
    },
};


const Services = () => {
    const navigate = useNavigate();
    const carouselRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [responsiveStyles, setResponsiveStyles] = useState(getCardStyles());
    const [isSliding, setIsSliding] = useState(true); 
    const [hoveredIndex, setHoveredIndex] = useState(null); 
    const [selectedCardIndex, setSelectedCardIndex] = useState(null); 
    
    const services = [
       { title: 'RovoConnect', description: 'RovoConnect is a Unified edge intelligence that transforms raw machine data into predictive insights, eliminating downtime and maximizing OEE in real-time.',path: '/rovoconnect', image: '/images/projects/rovovision.png' }, 
        { title: 'RovoVision', description: 'RovoVision is an AI-powered visual supervisor that automates safety and SOP compliance, transforming existing CCTV into real-time operational intelligence.',path: '/rovovision', image: '/images/projects/rovovisionn(2).png' },
        { title: 'User Identification', description: 'Advanced Face Identification, biometric and RFID-based user identification systems for secure access control and workforce tracking.', path: '/user',image: '/images/projects/serviesss.png' },
        { title: 'Andon System', description: 'Real-time visual management system that alerts Team about the production issues, enabling quick response and minimizing downtime.',path: '/andon', image: '/images/projects/services.png' },
        { title: 'OEE Dashboard', description: 'Comprehensive Overall Equipment Effectiveness dashboard providing real insights about production performance and efficiency.',path: '/OEE', image: '/images/projects/oee dash.png' },
        { title: 'Visitech', description: 'Smart visitor management system with digital check-in, badge printing, and real-time tracking for enhanced security.',path: '/visitech', image: '/images/projects/visitech rovo.png' },
         { title: 'RovoPeople', description: 'Centralize employee data, automate payroll, and streamline attendance—all in real time.',path: '/Rovopepole', image: '/images/projects/why.jpeg' },
       
    ];
   
    const handleMouseEnter = (index) => {
        if (selectedCardIndex === null) {
            setIsSliding(false); 
        }
        setHoveredIndex(index);
    };

    const handleMouseLeave = () => {
        if (selectedCardIndex === null) {
            setIsSliding(true); 
        }
        setHoveredIndex(null);
    };
    
    
   const handleClick = (index) => {
    const selectedService = services[index];

    // 🔹 Navigate to the page
    if (selectedService?.path) {
        navigate(selectedService.path);
    }

    // 🔹 Keep your existing logic untouched
    if (selectedCardIndex === index) {
        setSelectedCardIndex(null);
        setIsSliding(true);
    } else {
        setSelectedCardIndex(index);
        setIsSliding(false);
    }
};



    const getCardSelectStyle = (index) => {
        const isSelected = index === selectedCardIndex;
        const isHovered = index === hoveredIndex;

        let boxShadow = '0 1px 3px rgba(255, 255, 255, 0.93), 0 1px 2px rgba(0,0,0,0.24)'; 

        if (isHovered && !isSelected) {
            boxShadow = '0 4px 8px rgba(246, 246, 255, 0.93), 0 2px 4px rgba(0,0,0,0.2)'; 
        }

        if (isSelected) {
            boxShadow = '0 8px 16px rgba(0,0,0,0.4)';
        }

        return {
            transition: 'border 0.2s ease, box-shadow 0.2s ease', 
            transform: 'translateY(0) scale(1)',
            boxShadow: boxShadow,
            cursor: 'pointer',
            border: isSelected ? '3px solid #fbfdffff' : '3px solid transparent', 
        };
    };


    
    useEffect(() => {
        const handleResize = () => {
            setResponsiveStyles(getCardStyles()); 
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    
    useEffect(() => {
        const carouselElement = carouselRef.current;
        if (!carouselElement || !isSliding) return; 

        let cardsInView;
        const width = window.innerWidth;
        if (width >= 992) {
            cardsInView = 4;
        } else if (width >= 768) {
            cardsInView = 2.5;
        } else {
            cardsInView = 1.5;
        }
        
        const itemWidth = (carouselElement.offsetWidth / cardsInView); 
        const cardCount = services.length;
        
        const slideInterval = setInterval(() => {
            const nextIndex = (currentIndex + 1);
            
            if (nextIndex <= cardCount - Math.floor(cardsInView)) {
                carouselElement.scrollLeft += itemWidth; 
                setCurrentIndex(nextIndex);
            } else {
                carouselElement.scrollLeft = 0;
                setCurrentIndex(0);
            }
            
        },1500); 

        return () => clearInterval(slideInterval);
        
    }, [currentIndex, services.length, isSliding]); 


    return (
       
        <section id="services" className="mt-5"> 
            <div className="container pt-3 pb-3"> 
                
                <div className="row mb-5"> 
                    <div className="col-lg-8 mx-auto text-center">
                        <h2 className="font-weight-600 mb-2">Our Product</h2> 
                        <hr className="heading-separator-line border-primary border-2 d-block mx-auto" />
                        <p className="text-3 mb-3">We specialize in IoT integration and automation engineering solutions that streamline operations, enhance productivity, and drive digital transformation for businesses worldwide.</p>
                    </div>
                </div>
                
             
                <div style={baseStyles.scrollingRowContainer} ref={carouselRef}> 
                    {/* Flex row container */}
                    <div style={baseStyles.scrollingRow}>
                        {services.map((service, index) => (
                            <div 
                                key={index} 
                                style={{ ...responsiveStyles.cardSlideItem, ...getCardSelectStyle(index) }}
                                onMouseEnter={() => handleMouseEnter(index)}
                                onMouseLeave={handleMouseLeave}
                                onClick={() => handleClick(index)} 
                            >
                                <div className="featured-box bg-white h-100 py-2">
                                    
                                   
                                    <img 
                                        src={service.image} 
                                        alt={service.title} 
                                        style={responsiveStyles.image} 
                                        className="d-block mb-4" 
                                    />
                                    <div className="px-4"> 
                                        <h3 className="mb-0">{service.title}</h3>
                                        <p className="mt-1">{service.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                
            </div>
        </section>
    );
};

export default Services;